<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import ../DevisForm/sass/popinDevis
</style>

<template>
    <Zone
        :id="$json.hero.id"
        :dataLabel="$json.hero.dataLabel"
        contrast="light"
        class="g_hero">
        <Logo :baseline="true" />
        <div class="g_popinDevis">
            <div class="g_text">
                <Paragraph :content="data.devis.title" size="XL" />
                <Cta
                    v-if="config.links.int.link"
                    type="text"
                    class="g_btn g_btnBuy g_btnDevis"
                    :link="config.links.int.link"
                    target="_self"
                    :content="config.links.int.cta" />
                <Paragraph v-if="config.links.rooms.link" :content="data.devis.or" size="L" />
                <Cta
                    v-if="config.links.rooms.link"
                    type="text"
                    class="g_btn g_btnBuy g_btnDevis"
                    :link="config.links.rooms.link"
                    target="_self"
                    :content="config.links.rooms.cta" />
                <Paragraph v-if="config.links.ext.link" :content="data.devis.or" size="L" />
                <Cta
                    v-if="config.links.ext.link"
                    type="text"
                    class="g_btn g_btnBuy g_btnDevis"
                    :link="config.links.ext.link"
                    target="_self"
                    :content="config.links.ext.cta" />
                <Paragraph :content="data.devis.subtitle" size="L" />
            </div>
        </div>
    </Zone>
</template>

<script>
import Logo from '../../components/Logo'

export default {
    name: 'MailingDevis',
    components: {
        Logo
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        }
    },
    methods: {
        pageIs (page) {
            return this.$landing.project === page
        }
    }
}
</script>
